const DB_NAME = "portwatch-agent";
const DB_VERSION = 1;
const DATASETS_STORE = "datasets";

function resolveIndexedDB() {
  try {
    return globalThis.indexedDB ?? null;
  } catch {
    return null;
  }
}

// DBを開く。IndexedDB不在（Nodeテスト等）ならnullを返し、呼び出し側でno-opにする。
function openDb() {
  const idb = resolveIndexedDB();
  if (!idb) return Promise.resolve(null);

  return new Promise((resolve) => {
    let request;
    try {
      request = idb.open(DB_NAME, DB_VERSION);
    } catch {
      resolve(null);
      return;
    }

    request.onupgradeneeded = () => {
      const db = request.result;
      if (!db.objectStoreNames.contains(DATASETS_STORE)) {
        db.createObjectStore(DATASETS_STORE, { keyPath: "id" });
      }
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => resolve(null);
  });
}

function runWrite(mode, action) {
  return openDb().then((db) => {
    if (!db) return undefined;
    return new Promise((resolve, reject) => {
      const tx = db.transaction(DATASETS_STORE, mode);
      const store = tx.objectStore(DATASETS_STORE);
      action(store);
      tx.oncomplete = () => resolve(undefined);
      tx.onerror = () => reject(tx.error);
      tx.onabort = () => reject(tx.error);
    });
  });
}

export function idbPut(record) {
  return runWrite("readwrite", (store) => store.put(record));
}

export function idbDelete(id) {
  return runWrite("readwrite", (store) => store.delete(id));
}

export function idbClear() {
  return runWrite("readwrite", (store) => store.clear());
}

export function idbGetAll() {
  return openDb().then((db) => {
    if (!db) return [];
    return new Promise((resolve) => {
      const tx = db.transaction(DATASETS_STORE, "readonly");
      const request = tx.objectStore(DATASETS_STORE).getAll();
      request.onsuccess = () => resolve(request.result ?? []);
      request.onerror = () => resolve([]);
    });
  });
}
